// DO NOT EDIT THIS FILE!
// This file is autogenerated by the Parcel web application bundler.

import './app';
import '../../blocks/expandable-list/scripts/view';
import '../../blocks/grid/scripts/view';
import '../../blocks/hero/scripts/view';
import '../../blocks/image/scripts/view';
import '../../blocks/instagram-feed/scripts/view';
import '../../blocks/map/scripts/view';
import '../../blocks/read-more-button/scripts/view';
import '../../blocks/rich-text/scripts/view';
import '../../blocks/spacer/scripts/view';
import '../../blocks/selected-products/scripts/view';
import '../../blocks/tab-menu/scripts/view';
import '../../blocks/table/scripts/view';
import '../../blocks/video/scripts/view';
import '../../blocks/hotspot/scripts/view';
